import { Build, Component, Element, h, Host, Prop, State, Watch } from '@stencil/core';

@Component({
  tag: 'staedtler-lazy-background',
})
export class LazyBackground {
  @Element() el!: HTMLElement;
  @Prop() src!: string;
  @State() image: string;
  observer: IntersectionObserver;

  @Watch('src')
  watchId() {
    this.disconnectedCallback();
    this.componentDidLoad();
  }

  async componentDidLoad() {
    if (!Build.isBrowser) {
      return;
    }
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries
          .filter(entry => entry.isIntersecting)
          .forEach(entry => {
            this.image = this.src;
            observer.unobserve(entry.target);
          });
      },
      { rootMargin: '200px' },
    );
    this.observer.observe(this.el);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  render() {
    const props = {};
    if (this.image) {
      props['style'] = {
        'background-image': `url(${this.image})`,
      };
    }

    return (
      <Host {...props}>
        <slot />
      </Host>
    );
  }
}
